import React from "react";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import { CyClass } from "../../../../common/cy-classes";
import { ProfileBoxMessagesIndicator } from "../profile-box-messages-indicator.component";

@observer
export class FreePlayIndicatorComponent extends OrbitComponent {
    public render() {
        return (
            <ProfileBoxMessagesIndicator
                numberOfAwaitingMessages={this.services.freePlay.userVouchers.length}
                className = {CyClass('cy-free-play-indicator-button')}
                iconComponent = {this.services.theme.currentTheme.icons.freeplayIcon}
                text = {this.services.translation.translate('FREEPLAY_INDICATOR')}
                onClick={() => {
                    this.services.analytics.sendAnalytics(
                        "Navigation",
                        "NavBar",
                        "Open_Rewards"
                    );
                    this.services.userMenu.openRewards();
                }}
            />
        );
    }
}
